import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ITransactionReportParams } from "./models";

type InitialState = {
  transactionReportParams: ITransactionReportParams;
};

const initialState: InitialState = {
  transactionReportParams: {},
};

const reportSlice = createSlice({
  name: "data-generation",
  initialState: initialState,

  reducers: {
    updateTransactionReportParams: (state, action: PayloadAction<ITransactionReportParams>) => {
      state.transactionReportParams = action.payload;
    },
  },
});

export default reportSlice.reducer;
export const { updateTransactionReportParams } = reportSlice.actions;
